// extracted by mini-css-extract-plugin
export default {"item_list":"FormatColumn_item_list__ap-tz","myHandle":"FormatColumn_myHandle__vO-bb","hide-li":"FormatColumn_hide-li__upx6G"};